module.exports = __webpack_public_path__ + "static/media/Indoor Plant 15.e38f386e.svg";